import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {OptionsResponse, PaymentOption} from '../../../interfaces/payment-option';
import {Session} from 'src/app/interfaces/session-data';
import {ChargeResponse} from 'src/app/interfaces/charge-request';
import {TransactionService} from 'src/app/services/transaction/transaction.service';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {SetPaymentStepAfripay} from '../../shared/map.actions';
import {Store} from '@ngxs/store';
import {GoogleAnalyticsService} from '../../../services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss']
})
export class WalletComponent implements OnInit {
  @ViewChild('paymentMethodBackground') paymentMethodBackground: ElementRef;

  // loader
  loading: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  sessionData: Session;
  paymentMethod: string = "";

  // -- payment instructions

  public boxShadow = '0px 6px 12px 0px rgba(0,0,0,0.5 )';
  chargeResponse: ChargeResponse;
  mobile: Boolean = false;

  public wallet = {
    img: '',
    name: '',
    id: 0
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private transactionService: TransactionService,
    private breakpointObserver: BreakpointObserver,
    private store: Store,
    private googleAnalyticsService: GoogleAnalyticsService)
    {
      breakpointObserver.observe([
        Breakpoints.HandsetPortrait
      ]).subscribe(result => {
        if (result.matches) {
          //this.activateHandsetLayout();
          this.mobile = true;

        } else {
          this.mobile = false;
        }
      })
    }

  optionsResponse: OptionsResponse;
  paymentOptions: PaymentOption[];

  ngOnInit(): void {
    this.store.dispatch(new SetPaymentStepAfripay("STEP_ONE"));

    this.paymentMethod = 'wallet';

    this.sessionData = JSON.parse(sessionStorage.getItem("sessionData"));
    // this.transactionService.getPaymentOptions(this.sessionData).subscribe((data:OptionsResponse) => {
      // this.googleAnalyticsService
      // .eventEmitter('checkout_progress', 'afripay', 'choose_wallet', this.sessionData.originatingTransactionId, 1);

      // this.optionsResponse = data;
      // this.paymentOptions = this.optionsResponse.paymentOptions;
      // sessionStorage.setItem("transactionId", this.optionsResponse.transactionId);
      // this.loading = false;
   //  });

  }

  chooseWallet(name, logoUrl, id) {
    this.wallet.name = name;
    this.wallet.img = logoUrl;
    this.wallet.id = id;

    this.googleAnalyticsService
      .pushDirectEvent('virtual.payments.wallet.component', 'choose-wallet', this.wallet.name);
    this.googleAnalyticsService
      .pushDataLayerVariable('session.token', sessionStorage.getItem('sessionToken'));
    this.router.navigate(['processing'], { state: { wallet: this.wallet }, relativeTo: this.route.parent });
  }

}
